const initialState = {
  updatePasswordEdit: {
    isSubmitting: false,
    isComplete: false,
    isError: false,
    updatePasswordData: {},
  },
};

const updatePasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'updatePassword/FETCH_UPDATE_PASSWORD': {
      return {
        ...state,
        updatePasswordEdit: {
          ...state.updatePasswordEdit,
          isComplete: true,
          isError: false,
          updatePasswordData: {},
        },
      };
    }
    case 'updatePassword/BAD_REQUEST': {
      const message = action.payload.message;
      return {
        ...state,
        updatePasswordEdit: {
          ...state.updatePasswordEdit,
          isError: true,
          message: message,
          isConfirm: false,
          isSubmitting: false,
          updatePasswordData: {},
        },
      };
    }
    case 'updatePassword/INIT_STATE': {
      return initialState;
    }
    default:
      return state;
  }
};

export { updatePasswordReducer as default };
